/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { AppNavCancelButton } from './appNavBits/AppNavButtons';
import SearchForm from './appNavBits/SearchForm';
import AppNavContent from './appNavBits/AppNavContent';

import { NavigationRow, GeneralRow } from './appNavBits/AppNavRow';
import Spacer from '../../components/Spacer';

class AppNavSearch extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);

    this.state = {
      searchQuery: this.props.query || '',
    };
  }

  onChange(event) {
    this.setState({
      searchQuery: event.target.value,
    });

    this.props.onChangeQuery(event.target.value);
  }

  onClearField = () => {
    const { onClearField } = this.props;

    this.setState({ searchQuery: '' });
    if (onClearField) {
      onClearField();
    }
  }

  render() {
    return (
      <div>
        <AppNavContent>
          <NavigationRow>
            <AppNavCancelButton onClick={this.props.cancelSearch} color="white" />
          </NavigationRow>

          <Spacer size="10" />

          <GeneralRow>
            <SearchForm
              onChange={this.onChange}
              submitSearch={() => { this.props.submitSearch(this.state.searchQuery); }}
              value={this.state.searchQuery}
              placeholder={this.props.queryPlaceholder}
              clearField={this.onClearField}
            />
          </GeneralRow>
        </AppNavContent>
      </div>
    );
  }
}
AppNavSearch.propTypes = {
  query: PropTypes.string,
  queryPlaceholder: PropTypes.string,
  cancelSearch: PropTypes.func.isRequired,
  submitSearch: PropTypes.func.isRequired,
  onChangeQuery: PropTypes.func.isRequired,
  onClearField: PropTypes.func,
};

export default AppNavSearch;
